import React, {useState} from 'react';


export const InputRadio = ({question, setState, indexOfFirst, setIndexOfFirst})  => {

    return (
      <div className="my-2">
        <h1 className="text-3xl font-bold my-2">{question.label}</h1>
            <label className="block text-sm my-1 font-medium text-gray-900">
                {question.info} {question.required? '*': null}
            </label>
            {question.options.map((option,index) => {
                return (
                        <div className="flex items-center ps-3" key={option}>
                            <input
                            type="radio"
                            id={`radio-${option}`}
                            name={question?.id}
                            value={option}
                            defaultChecked={index===indexOfFirst}
                            onChange={event => {
                                setState(event.target.value);
                                setIndexOfFirst(index);
                            }}
                            required={question.required}
                            className="radiobtn"/>
                            <label htmlFor={`radio-${option}`} className="ms-2 text-m font-medium text-gray-900">{option}</label>
                        </div>
                )
            })}
      </div>
    );
}